























import { Component, Vue, Emit, Prop } from 'vue-property-decorator';
import { ALL_CARS } from '@/queries/Car';
import { GQL_deleteCar_deleteCar_car } from '@/queries/__generated__/deleteCar';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { GQL_currentUnitCars, GQL_currentUnitCars_currentUnit_cars } from '@/queries/__generated__/currentUnitCars';
import gql from 'graphql-tag';

const DELETE_CAR = gql`
  mutation deleteCar($id: ID!) {
    deleteCar(
      input: {
        id: $id,
      }
    ) {
      car {
        id
      }
    }
  }
`;

@Component
export default class CarDeleteButton extends Vue {
  @Prop() public car!: GQL_currentUnitCars_currentUnit_cars;
  public DELETE_CAR = DELETE_CAR;

  @Emit('car-deleted')
  public removeFromCache(
    store: InMemoryCache,
    { data: { deleteCar: { car } } }: {data: {deleteCar: {car: GQL_deleteCar_deleteCar_car}} },
  ) {
    const data = (store.readQuery({ query: ALL_CARS }) as GQL_currentUnitCars);
    data.currentUnit.cars = data.currentUnit.cars.filter(c => c.id !== car.id);
    store.writeQuery({ query: ALL_CARS, data });
  }

  public confirmDelete(confirmMutation: () => {}) {
    this.$sPopup.confirm(``, {
      title: this.$t('PopupTitle.confirmDelete'),
      message: this.$t('PopupBody.confirmDelete', { thing: this.car.registrationNumber || this.car.name }),
      onConfirm: confirmMutation,
    });
  }
}
